import React, { Component } from "react";
import { FontAwesomeIcon }         from '@fortawesome/react-fontawesome'
import { Button, Modal, PageHeader, FormGroup, InputGroup, FormControl, ListGroup, ListGroupItem } from "react-bootstrap";
import { invokeApig }              from '../../libs/awsLib';
import { Link, Routes }            from 'react-router-dom'
import LoaderButton                from "../../components/LoaderButton";
import FooterLoadingBar            from "../../components/utils/FooterLoadingBar";
import SortDropdownClientAssessment       from "../../components/utils/SortDropdownClientAssessment";
import RenderLander                from "../../components/utils/RenderLander";
import { handleGoToURL}            from "../../utils/URL";
import { getFiletypeIcon }         from "../../utils/Icons"
import uniqueId                    from 'lodash/uniqueId';
import { s3Delete }                from "../../libs/awsLib";
import { Colors }                  from "../../utils/Colors";
import AddNewAssessmentDropdownMenu from "../../components/assessment/AddNewAssessmentDropdownMenu";
import { convertImageAttributes, compareExistingToNewImages } from "../../screens/assessment/utils";
import {
         invokeGetAssessmentsListAll,
         invokeSetDeleteAssessment,
         invokeGetAssessmentDetail
       } from "../../utils/AwsInvoke";
import "../../css/assessment/AssessmentListAll.css";
import "../../css/form/Btn.css";

const uuidv1 = require('uuid/v1');

export default class AssessmentListall extends Component {
    constructor(props) {
        super(props);

        var search_term = `${this.props.match.params.search_term}`;
        if(search_term === "&") search_term = "";

        this.state = {
              isLoading: true, // default is true
              numberOfRows: 100,
              clientId: `${this.props.match.params.client_id}`,
              companyId: "",
              searchMsg: "",
              searchTerm: search_term,
              showLoadingBar:"none",
              sortBy: 1, // default sort by Name Asc
              pageOverlay: "none",
              showDeleteConfirmWin: false
        };
    }

    componentDidMount() {
        var that = this;
        if (!this.props.isAuthenticated) {
            return;
        }

        try {

            this.getAssessmentList();
        } catch (e) {
            alert(e);
        }
    }

    getAssessmentList = async event => {
        var number_of_rows = this.state.numberOfRows;
        this.setState({
            showLoadingBar: "inline"
        })

        //// If user searched for an Assessment and then hits the back button,
        //// take the user back to the search results page with the search term
        var search_term = this.state.searchTerm;
        var sort_by     = this.state.sortBy;
        //var company_id = this.props.globalCompanyId;
        var client_id   = this.state.clientId;

        // if a user deletes a member when viewing all member assessments, instead of a single member's assessment,
        // this valid id var ensures all assessments are re-listed after an assess. is deleted
        var valid_client_id = `${this.props.match.params.client_id}`;

        if(search_term === "&") search_term = "";
        if(client_id === "&" || valid_client_id === "&") client_id = "%"; // update value to reflect to search all clients in db

        const results = await invokeGetAssessmentsListAll(client_id, number_of_rows, sort_by, search_term);

        if(results) {

            this.setState({
                assessments: results,
                isLoading: false,
                showLoadingBar: "none"
            });
        } else
            this.setState({ isLoading: false, showLoadingBar: "none" })
    }

    clearSearchField = () => {
        // RESET URL
        this.props.history.replace("/assessment/listAllAssessments/&/&")

        this.setState({
            searchTerm: "", // reset search term if resetting assessment list
        })
    }

    searchAssessment = async () => {
        var search_term = this.state.searchTerm;

        if(this.searchInput != undefined) {
            search_term = this.searchInput.value;

            if(search_term.length === 0) search_term = "&";

            this.props.history.replace("/assessment/listAllAssessments/&/"+search_term)

            //// RESET Search Textfield
            if(search_term === "&") {
                this.setState({
                    searchTerm: "", // reset search term if resetting document list
                    searchMsg: ""   // clear search message
                }, function () {
                    this.getAssessmentList();
                })
                return
            }
        }

        var client_id      = this.state.client_id;
        var company_id     = this.props.globalCompanyId;
        var sort_by        = this.state.sortBy;
        var number_of_rows = this.state.numberOfRows;

        if(client_id === "&") client_id = "%"; // update value to reflect to search all clients in db

        const results = await invokeGetAssessmentsListAll(client_id, number_of_rows, sort_by, search_term);// search_term.toLowerCase()

        if(results) {

            this.setState({
                assessments: results,
                searchTerm: search_term,
                searchMsg: "You have "+results.search_lgth+ " results when searching for '" + search_term + "'.",
                isLoading: false,
                showLoadingBar: "none"
            });
        } else {
            this.setState({
                isLoading: false,
                showLoadingBar: "none"
            });
        }
    }

    sortResults = (sort) => {
        // Sort: 1 = Filename: Asc | 2 = Filename: Desc | 3 = Filetype: Asc | 4 = Filetype: Desc

        this.setState({
            sortBy: sort,
            assessments: null // reset assessments object otherwise the assessments list will re-render multiple times
        }, function(){
            this.getAssessmentList();
        })
    }

    handleKeyPress = (target) => {
        // Allow user to hit "Enter" when using Search box //
         if(target.charCode === 13)
            this.searchAssessment();
    }

    handlePreURL = (e, that, assessment_id, client_id) => {
        var tmp_client_id = this.state.clientId;
        if(tmp_client_id != "&") client_id = tmp_client_id;

        handleGoToURL(e, that, "/assessment/edit/"+client_id+"/"+assessment_id+"/no_type");
    }

    renderAssessmentsList(assessments) {

          var search_msg     = "";
          var tmp_search_msg = this.state.searchMsg;

          search_msg = <div key={uniqueId()} className="exerciseHeaderButtons">
                            <span style={{position:"relative", top:"7px", left:"7px", fonySize: "19px"}}>
                             { tmp_search_msg }
                            </span>

                            <span className="pull-right">
                                <SortDropdownClientAssessment sortResults={this.sortResults.bind(this)} />
                            </span>
                       </div>

            if(assessments != null) {
                  return [{}].concat(assessments.title).map(
                    (assessment, i) =>
                      i !== 0 ?
                              <div key={uniqueId()} className="grid exerciseListGrid">
                                    <span className="assessmentListRowLeft">
                                            <span className="ListSingleRowThumb">
                                                {(new Date(assessments.date[i-1])).toLocaleString('en-US', { month: 'short', day: 'numeric' })}
                                                <div className="assessmentListRowDateYear">
                                                    {(new Date(assessments.date[i-1])).toLocaleString('en-US', { year: 'numeric' })}
                                                </div>
                                            </span>
                                    </span>
                                    <span   className="assessmentListAllRowMiddleLeft"
                                            onClick={(e) => this.handlePreURL(e, this, assessments.id[i-1], assessments.client_id[i-1])}> { /*`/document/edit/${this.state.clientId}/${assessments.id[i-1]}`)}>*/ }
                                          <span className="documentListNameSingleRow">
                                              { i + ". " + assessment}
                                          </span>
                                          <div>
                                              <span className="assessmentClientListAllMemberCol" >
                                                  Member: { assessments.name[i-1] }
                                                  <span style={{display:"inline-block",paddingLeft:45}}/>
                                                  Created by: { assessments.creator_name[i-1] }
                                                  <br/>
                                                  { assessments.assessment_type[i-1] }
                                              </span>
                                          </div>
                                          { /*}
                                              <span className="documentClientListAllDateFormat" >
                                                  <span className="documentListAllDateFormat">Created: { (new Date(assessments.date[i-1])).toLocaleString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) }</span>
                                              </span>
                                              */ }
                                    </span>
                                    <span className="clientListRowRight" style={{float:"right",zIndex:1000,backgroundColor: "transparent"}}>
                                            <span className="documentListDeleteCol pullRight"
                                                  onClick={(e) => this.handleDeleteAssessment(e, assessment, assessments.id[i-1], assessments.client_id[i-1], assessments.type_number[i-1])}>
                                                <span className = "glyphicon glyphicon-remove-circle glyphiconRemoveAssessmentBtn"
                                                      style     = {{color:Colors.delete_button_bg}}/>
                                            </span>
                                    </span>
                            </div>

                            :
                            <span key={uniqueId()} >
                                <div className="exerciseHeaderSearchBar">
                                    <span>
                                        <FormGroup>
                                           <InputGroup>
                                             <FormControl key = {uniqueId()}
                                                          type="text"
                                                          placeholder=""
                                                          defaultValue={this.state.searchTerm}
                                                          inputRef={ref => { this.searchInput = ref; }}
                                                          onKeyPress={this.handleKeyPress}
                                                      />

                                               <span className="glyphicon glyphicon-remove-circle searchInputClearBtn"
                                                     onClick={() => this.clearSearchField()}
                                               />
                                               <InputGroup.Button>
                                                 <Button style={{ display:"inline-block", height:"34px",backgroundColor: Colors.search_button_bg, color:"white", borderRadiusInputTopRight: "5px" }} onClick={() => this.searchAssessment()}>Search</Button>
                                               </InputGroup.Button>
                                           </InputGroup>
                                         </FormGroup>
                                  </span>
                              </div>
                              { search_msg }

                              { i === 0 && assessments.title == "" ?
                                    <ListGroupItem className="exerciseListGrid"
                                                   style={{height:400, backgroundColor:"transparent"}}>
                                        <br/>
                                    You currently have 0 assessments.
                                    </ListGroupItem>

                                : null }
                          </span>
                  );
             }
    }

    handleDeleteAssessment = async (event, title, assessment_id, client_id, assessment_type) => {
        event.preventDefault();
        var tmp_client_id = this.state.clientId;

        if(tmp_client_id != "&") client_id = tmp_client_id;

        this.setState({
            pageOverlay: "inline",
            showDeleteConfirmWin: true,
            clientId: client_id,
            assessmentId: assessment_id,
            assessmentType: assessment_type,
            currentDocumentName: title
        });
    }

    getNext100Results = () => {
        var tmp_rows = this.state.numberOfRows;
        tmp_rows = tmp_rows + 100;

        this.setState({
            numberOfRows: tmp_rows
        }, function(){
            this.getAssessmentList();
        })
    }

    handleAddAssessment = (item) => {
        console.log(">>>>>>>>> item: " + item);
        var assess_type = "freeform";
        if(item == 2) assess_type = "inbody";
        else if(item == 3) assess_type = "fms";
        else if(item == 4) assess_type = "heartandblood";
        else if(item == 5) assess_type = "lowerbodypower";
        else if(item == 6) assess_type = "parq";
        else if(item == 7) assess_type = "primalmovement";
        else if(item == 8) assess_type = "strength";
        else if(item == 9) assess_type = "jointrom";
        else if(item == 10) assess_type = "spinalrom";
        else if(item == 11) assess_type = "bodycomp";
        else if(item == 12) assess_type = "girth";

        var url = `/assessment/new/${this.state.clientId}/&/${assess_type}`;
        this.props.history.push(url);
    }

    renderPrograms() {
        var next_100;
        var user = ": All Members";

        var assessment      = this.state.assessments;
        var client_id = `${this.props.match.params.client_id}`;


        if(assessment != undefined && client_id != "&") {

            // If viewing a member's detail page, show fullname
            var tmp_user = assessment.name[0];
            if(tmp_user != undefined) {
                user =  <span className=""
                              href= {"/client/detail/"+client_id}
                              style={{cursor:"pointer"}}
                              onClick={(e) => handleGoToURL(e, this, "/client/detail/"+client_id)}>
                                 { ": " } <span style={{color:Colors.ok_button_bg}}>{tmp_user}</span>
                        </span>
            } else
                user = "";
        }

        //if(!this.state.isLoading)
        //    next_100 = <span style={{display:"inline-block", width:"100%", textAlign:"center", fontSize:"18px", cursor:"pointer"}} onClick={() => this.getNext100Results()}>Next 100 results >></span>

        if(this.state.searchMsg != "") next_100 = ""; // if user is searching for a assessment, hide "next 100 results" msg

        return (
              <div className="programs">
                <PageHeader>
                        <span style={{width:"220px"}}>
                            <FontAwesomeIcon icon="notes-medical" style={{ position:"relative", top:6, fontSize: '1.6em', color: Colors.primary_color, paddingRight:"16px" }}/>
                             Assessments{ user }
                        </span>

                        <span className="pull-right" style={{ position:"relative", top:9, right: 22}}>
                            { /*}<Button className = "btnClientAddNew"
                                    onClick={(e) => handleGoToURL(e, this, `/assessment/new/${this.state.clientId}/&`)}>
                                Add New
                            </Button> */}
                            <AddNewAssessmentDropdownMenu handleProgram = {() => this.handleAddAssessment.bind(this)} />
                        </span>
                </PageHeader>

                <ListGroup style={{display: "inline-block"}}>
                    {!this.state.isLoading && this.renderAssessmentsList(this.state.assessments)}
                </ListGroup>
                { next_100 }
                <br/><br/><br/><br/>
              </div>
        );
    }

    async deleteAssessment () {
        this.setState({
            //pageOverlay: "none",
            showDeleteConfirmWin: false,
            loadingData: "Deleting assessment ... ",
            showLoadingBar: "inline"
        });
        var client_id       = this.state.clientId
        var assessment_id   = this.state.assessmentId;
        var assessment_type = this.state.assessmentType;
        var action          = ""; // other option: new
        // Step 1. Delete Source File from AWS S3
        //const resultsDeleteFile = await s3Delete(this.state.assessmentId); // delete actual file from S3
        var screen = "getGeneralAssessment";
        const results = await invokeGetAssessmentDetail(screen, action, client_id, assessment_id);

        if(results) {
            var data     = results.data.client_data[0];
            var content  = data.content;

            let tmp_obj             = convertImageAttributes(content);
            let new_images_arr      = [];
            let existing_images_arr = tmp_obj.tmp_img_src_arr; //this.state.existingEditorImages;

            // DELETE ALL AWS S3 IMAGES
            // STEP 1. GET CONTENT OF JSON FILE from DB
            // STEP 2. EXTRACT AWS ID FROM "CONTENT"
            // STEP 3. DELETE AWS IMAGE FROM S3
            var compare = await compareExistingToNewImages(existing_images_arr, new_images_arr)

            if(compare) {
                // Step 4. Delete File Data from Database
                const resultsDeleteDBData = await invokeSetDeleteAssessment(client_id, assessment_id, assessment_type);

                if(resultsDeleteDBData.status) {
                    this.getAssessmentList();
                } else this.getAssessmentList();
            }
        }
    }

    handleCloseDeleteConfirmWin = (action) => {
        if(action === "delete") this.deleteAssessment();
            else this.setState({ pageOverlay: "none", showDeleteConfirmWin: false });
    }

    render() {

        return (
              <div className="ProgramList">
                {this.props.isAuthenticated ? this.renderPrograms() : <RenderLander />}

                <FooterLoadingBar text={"Retrieving assessments ..."}
                                  showLoadingBar={this.state.showLoadingBar}/>

                  <div>
                        <span className="pageOVerlay" style={{display:this.state.pageOverlay}}></span>
                        <Modal
                               show={this.state.showDeleteConfirmWin}
                               onHide={() => this.handleCloseDeleteConfirmWin("close")}
                               aria-labelledby="contained-modal-title"
                             >
                               <Modal.Header closeButton>
                                 <Modal.Title id="contained-modal-title">
                                   Confirm Assessment Deletion
                                 </Modal.Title>
                               </Modal.Header>
                               <Modal.Body>
                                 Are you sure you want to delete "<span style={{fontWeight:"bold"}}>{ this.state.currentDocumentName }</span>" PERMANENTLY?
                               </Modal.Body>
                               <Modal.Footer>
                                   <Button className="modalBasicsBtnClose" onClick={() => this.handleCloseDeleteConfirmWin("close")}>Cancel</Button>
                                   <span className="modalBasicsFooterXPosSpacer"/>
                                   <LoaderButton
                                       bsSize    = "large"
                                       //disabled  = {!this.validateForm()}
                                       //type      = "submit"
                                       btncolor    = { Colors.delete_button_dark_red_bg }
                                       height      = {38}
                                       width       = {125}
                                       isLoading   = {this.state.isLoading}
                                       text        = "Yes, Delete"
                                       loadingText = "" //"Deleting program…"
                                       onClick     = {() => this.handleCloseDeleteConfirmWin("delete")}
                                   />
                               </Modal.Footer>
                         </Modal>
                  </div>
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/assessment/AssessmentListAll.js